<template>
  <div>
    <div class="d-flex" id="wrapper">
      <div id="page-content-wrapper">
        <nav
          class="
            navbar navbar-expand-lg navbar-light
            bg-na-principal
            border-bottom
            fixed-top
            custom-navbar
            shadow-sm
          "
        >
          <div class="sidebar-heading">
            <img :src="logoImgUrl" width="190px" height="63px" alt="logo" />
          </div>
          <div
            class="collapse navbar-collapse show float-right left"
            id="navbarSupportedContent"
          >
            <ul
              class="navbar-nav mr-auto mt-2 mt-lg-0 d-flex align-items-center"
            >
              <li
                id="action-item-notification"
                class="nav-item dropdown no-arrow mx-1"
                style="display: contents"
              >
                <!-- User Profile -->
                <custom-user-info-panel
                  class="ml-3 custom-user-info"
                  :row-elements="userCard.rowElements"
                  :row-actions="userCard.rowActions"
                  :last-login-date="userCard.lastLogin"
                />
              </li>
            </ul>
          </div>
        </nav>
      </div>
      <passwordmodal />
    </div>
  </div>
</template>

<script>
import passwordmodal from './ChangePasswordModal';
import CustomUserInfoPanel from 'CustomUserInfoPanel';

import logoUrl from "@/assets/img/logo.png";
import logoTrainingUrl from "@/assets/img/logo-training.svg"

export default {
  components: {
    passwordmodal,
    CustomUserInfoPanel,
  },
  props: {
    userInfo: {
      type: Object,
      default: () => {},
    },
    excludeHelpCard: {
      type: Array,
      default: () => [], //array strings, para excluir items de caja de ayuda
    },
    contactInfo: {
      type: Object,
      default: () => ({
        phone: '787-773-6147',
        mail: 'apoyoconversion@de.pr.gov',
      }),
    },
  },
  data() {
    return {
      selectedStudent: false,
      hasStudentSelected: false,
    };
  },
  computed: {
    userCard() {
      return {
        rowElements: [
          {
            text: this.userInfo.role,
            icon: 'fas fa-key',
            colorIcon: 'orange',
            color: 'none',
            withBorder: false,
          },
          {
            text: this.userInfo.name,
            icon: 'fas fa-user',
            colorIcon: 'orange',
            color: 'none',
            withBorder: false,
          },
          {
            text: this.userInfo.email,
            icon: 'fas fa-envelope',
            colorIcon: 'orange',
            color: 'none',
            withBorder: false,
          },
        ],
        rowActions: [
          {
            text: 'Mi Perfil',
            icon: 'fas fa-address-card',
            colorIcon: 'green',
            color: 'green',
            withBorder: true,
          },
          {
            text: 'Cambiar Contraseña',
            icon: 'fas fa-repeat',
            click: this.ShowHidePasswordChange,
            colorIcon: 'green',
            color: 'green',
            withBorder: true,
          },
          {
            text: 'Salir',
            icon: 'fas fa-sign-out-alt',
            click: () => this.logout(),
            colorIcon: 'green',
            color: 'green',
            withBorder: true,
          },
        ],
        lastLogin: this.userInfo.lastLoginDate,
      };
    },
    helpCard() {
      let rowElements = [
        { text: 'Manual', icon: 'fas fa-book' },
        { text: 'Videos', icon: 'fas fa-video' },
      ];
      return {
        rowElements: rowElements.filter(
          (item) => !this.excludeHelpCard.includes(item.text)
        ),
      };
    },
    logoImgUrl(){
      if(this.isTrainingEnv())
        return logoTrainingUrl;
      return logoUrl;
    },
  },
  methods: {
    logout() {
      this.$emit('logout');
    },
    hideUserPanel() {
      const userPanel = document.getElementsByClassName('user-panel')[0];
      userPanel.lastElementChild.classList.remove('show');
    },
  },
};
</script>

<style scoped>
.div-help {
  margin-left: -10px;
  color: #ff7058;
}
.help-text {
  margin-left: -10px;
}
.help-information {
  margin-left: -10px !important;
}
.information-text {
  margin-left: -7px;
  font-family: 'Lato', sans-serif;
  font-size: 12px;
}
.support-table {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  opacity: 1;
}
.support-information {
  text-align: left;
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #20a874 !important;
  opacity: 1;
}
.support-label {
  margin-left: 11px !important;
  text-decoration: underline;
  font-family: 'Lato', sans-serif;
  font-size: 13px;
}
.shadow-top {
  -moz-box-shadow: inset 0 10px 10px -10px grey;
  -webkit-box-shadow: inset 0 10px 10px -10px grey;
  box-shadow: inset 0 10px 10px -10px grey;
}
.alert-indicator {
  position: absolute;
  top: 32px;
  right: 157px;
  background: #fd3737 0% 0% no-repeat padding-box;
  color: #fff;
  width: 15px;
  height: 15px;
  opacity: 1;
  line-height: 15px;
  text-align: center;
  font-size: 10px;
}

.dropdown-menu-custom {
  top: 95% !important;
}

.sidebar-heading {
  margin-left: -16px;
  margin-top: -10px;
  padding-top: 20px;
  margin-bottom: -9px;
  padding-left: 30px;
  padding-right: 55px;
  /* width: 20%; */
  height: 110px;
  position: absolute;
  top: -2px;
  left: 7px;
}

.bg-na-principal {
  background-color: #ffffff;
}

.custom-navbar {
  height: 85px;
}

span.greenHelp {
  color: #11291b;
  border: 1px solid #2db782;
  border-radius: 50px;
  display: inline-block;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.6em;
  text-align: center;
  width: 7.1875rem;
  height: 2.6875‬rem;
}

.iconNav1 {
  font-size: 1.225rem;
  color: #2db782;
}

.iconNav2 {
  font-size: 1.375rem;
  color: #2db782;
}

.nav-link {
  position: relative;
  padding: 1rem;
  font: Bold 16px/19px Lato;
  color: #11291b;
}
.nav-link:hover {
  color: rgb(98, 99, 98);
  background-color: transparent;
}
.nav-hover {
  display: none;
}

.nav-link:hover + .nav-hover {
  display: block;
}

.nav-link.active {
  color: #fff;
}
.nav-link.active:after {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 0;
  margin-left: -0.3rem;
  vertical-align: middle;
  content: '';
  border-right: 0.3rem solid transparent;
  border-bottom: 0.3rem solid;
  border-left: 0.3rem solid transparent;
}

/************ START ACCOUNT MENU ************/
.account-menu {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #e2e2e2;
  border-radius: 0px 0px 5px 5px;
  min-width: 296px;
  padding-top: 0px !important;
  margin-top: 1.35rem;
  width: 296px !important;
}

.account-menu span {
  color: #36484b;
  font-size: 16px;
  font-weight: bold;
}

.account-menu i {
  color: #ff7058;
  margin-right: 0.5rem;
  width: 16px;
  height: 16px;
}

.account-menu ul {
  background-color: #f2f2f2;
  padding: 1rem 0;
  list-style: none;
  padding-bottom: 0;
}

.account-menu ul a {
  text-decoration: none;
}

.account-menu ul a span {
  color: #2db782;
  text-decoration: underline;
}

.account-menu li {
  padding: 0.25rem 1rem;
}

.account-menu ul ul {
  padding: 0.5rem 0;
  padding-top: 0.5rem;
}

.account-menu > ul > li:last-child {
  background: rgb(224, 224, 224);
  background: linear-gradient(
    180deg,
    rgba(224, 224, 224, 1) 0%,
    rgba(255, 255, 255, 1) 100%
  );
  padding: 0.75rem 1rem;
}

.account-menu .sublist {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #e2e2e2;
  padding: 0.25rem 0 !important;
  margin-top: 0.75rem;
  min-height: 109px;
}

.account-menu .sublist ul {
  background: #ffffff 0% 0% no-repeat padding-box;
}
/************ START HELP OPTION ************/
.help-grid {
  top: 103px;
  left: 186px;
  width: auto;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #e2e2e2;
  border-radius: 0px 0px 5px 5px;
  opacity: 1;
}

.icon-hepl-grid {
  top: 123px;
  left: 930px;
  width: 16px;
  height: 18px;
  opacity: 1;
}

.text-hepl-grid {
  top: 122px;
  left: 958px;
  width: 54px;
  height: 19px;
  text-align: left;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
}
/************ END HELP OPTION ************/

/******************* START PROFILE *********************/

.nav-item .media {
  margin-left: 20px;
}

.nav-item .media em {
  font-size: 1.225rem;
}

.avatar {
  font-size: 1rem;
  display: inline-flex;
  width: 45px;
  height: 45px;
  color: #fff;
  border-radius: 50%;
  border: 1px solid #2db782;
  align-items: center;
  justify-content: center;
}

.iconNav {
  font-size: 1.225rem;
  color: #3f5b60;
}

.custom-user-info ::v-deep > .user-panel > .dropdown-menu {
  top: 3rem !important;
  margin-right: 0 !important;
  min-width: 15rem !important;
}

@media screen and (min-width: 768px) and (max-width: 991px) {
  .custom-user-info ::v-deep > .user-panel > .dropdown-menu {
    top: 2.7rem !important;
    margin-right: 0 !important;
    min-width: 15rem !important;
  }

  ul.navbar-nav li:nth-child(1) {
    display: flex !important;
  }
  ul.navbar-nav li:nth-child(1) div:nth-child(3) {
    margin-top: 0.34rem;
  }
}

@media screen and (max-width: 767px) {
  .custom-user-info ::v-deep > .user-panel > .dropdown-menu {
    top: 3rem !important;
    margin-right: 0 !important;
    min-width: 15rem !important;
  }
}

/******************* END PROFILE *********************/
</style>
